import { useState } from "react";
import ItemTile from "./ItemTile";
import { paletteFor } from "./palette";

interface ItemMediaProps {
  src?: string;
  name: string;
  itemKey: string;
  categoryName?: string;
  variant?: "card" | "hero";
}

const ItemMedia = ({ src, name, itemKey, categoryName, variant = "card" }: ItemMediaProps) => {
  const [errored, setErrored] = useState(false);
  const palette = paletteFor(categoryName);

  if (!src || !src.trim() || errored) {
    return <ItemTile name={name} itemKey={itemKey} palette={palette} variant={variant} />;
  }

  return (
    <img
      className={`media media--${variant}`}
      src={src}
      alt={name}
      loading="lazy"
      onError={() => setErrored(true)}
    />
  );
};

export default ItemMedia;
